<template>
    <div>
        <span v-for="(item, index) in numPages" :key="index">
            <pdf ref="pdf" :src="src" :page="index + 1"></pdf>
        </span>
    </div>
</template>

<script>
import pdf from "vue-pdf";
export default {
    components: {
        pdf,
    },
    props: ["pdfUrl"],
    mounted() {
        this.getUrlPdf();
    },

    data() {
        return {
            numPages: 1,
            src: null,
            loadings: null,
        };
    },
    beforeDestroy() {
        this.$notice.close(this.loadings);
    },
    methods: {
        getUrlPdf() {
            this.loadings = this.$notice.loading("PDF加载中...");
            this.src = pdf.createLoadingTask(this.pdfUrl);
            this.src.promise
                .then((pdf) => {
                    this.numPages = pdf.numPages;
                    this.$notice.close(this.loadings);
                })
                .catch(() => {
                    this.$notice.close(this.loadings);
                });
        },
    },
};
</script>

<style scoped lang="scss"></style>
